/*
  Wishlist on the product page carousels (More from brand, You may also like, Recently viewed).

  The wishlist app (WishlistSuite) adds its heart to product cards it recognises. It does not
  recognise these cards on the product page, so the heart there was only the theme's placeholder
  and saved nothing. This script:
    1. marks those cards with a class the app recognises and asks the app to scan again
    2. moves the app's heart into the card's action row, in the placeholder's slot
       (left of Add to cart), and removes the placeholder
  The card markup and look stay the same. If the app is off, the placeholder is left as it was.

  It also gives the round buttons on these cards (wishlist + Add to cart) the same hover as the
  perfume product card on the collection page: the button fades to black and its icon turns white.
*/
(function () {
  if (window.mbCardWishlistBound) return;
  window.mbCardWishlistBound = true;

  var ROOTS = ['mb-more-from-brand', 'mb-product-tabs', 'mb-recently-viewed'];
  var CARD = '[data-pcarousel-card]';
  var ACTIONS = '[class$="__actions"]';
  var WISH = '.product-card-wishlist-btn';
  var MARK = 'product-card';
  var HEART = ACTIONS + ' ' + WISH;
  var PLACEHOLDER = ACTIONS + ' [data-pcarousel-wishlist]';
  var CART = ACTIONS + ' button[name="add"]';
  var scheduled = false;

  function scope(rest) {
    return ROOTS.map(function (root) { return root + ' ' + rest; }).join(',');
  }

  function scopeAll(list) {
    return list.map(scope).join(',');
  }

  var style = document.createElement('style');
  style.textContent =
    scope(CARD + ' > ' + WISH + ':not([data-mb-placed])') +
    '{opacity:0!important;pointer-events:none!important}' +
    scope(HEART) +
    '{position:relative!important;inset:auto!important;flex:0 0 auto;order:-1;display:inline-flex!important;' +
    'align-items:center;justify-content:center;width:var(--mb-card-icon,32px)!important;' +
    'height:var(--mb-card-icon,32px)!important;min-width:0;min-height:0;margin:0 auto 0 0!important;' +
    'padding:0!important;border:0!important;border-radius:50%!important;background:#fff!important;' +
    'color:#29231f;box-shadow:0 0 10px rgba(0,0,0,.05)!important;opacity:1!important;' +
    'transition:transform .2s ease,box-shadow .2s ease,background-color .25s ease,color .25s ease!important}' +
    scope(HEART + ':hover') +
    '{transform:translateY(-2px);box-shadow:0 4px 14px rgba(0,0,0,.1)!important}' +
    scope(HEART + ' svg') +
    '{width:var(--mb-card-glyph,16px)!important;height:var(--mb-card-glyph,16px)!important}' +
    '.mb-mfb--hide-wishlist ' + WISH + ',.mb-tabs--hide-wishlist ' + WISH + ',.mb-rv--hide-wishlist ' + WISH +
    '{display:none!important}' +

    /* Hover: black button, white icon (wishlist + Add to cart) */
    scopeAll([CART, PLACEHOLDER]) +
    '{transition:transform .2s ease,box-shadow .2s ease,background-color .25s ease,color .25s ease!important}' +
    scopeAll([CART + ' svg *', HEART + ' svg *']) +
    '{transition:fill .25s ease,stroke .25s ease}' +
    scopeAll([HEART + ' svg', HEART + ' img', HEART + ' i', HEART + '::before', HEART + '::after']) +
    '{transition:filter .25s ease}' +
    '@media (hover:hover){' +
    scopeAll([CART + ':hover:not([disabled])', PLACEHOLDER + ':hover', HEART + ':hover']) +
    '{background:#000!important;color:#fff!important}' +
    scopeAll([
      CART + ':hover:not([disabled]) svg [stroke]:not([stroke="none"])',
      HEART + ':hover svg [stroke]:not([stroke="none"])'
    ]) +
    '{stroke:#fff!important}' +
    scopeAll([
      CART + ':hover:not([disabled]) svg [fill]:not([fill="none"])',
      HEART + ':hover svg [fill]:not([fill="none"])'
    ]) +
    '{fill:#fff!important}' +
    scope(CART + ':hover:not([disabled]) .loading__spinner .path') +
    '{stroke:#fff!important}' +
    scopeAll([
      HEART + ':hover svg',
      HEART + ':hover img',
      HEART + ':hover i',
      HEART + ':hover::before',
      HEART + ':hover::after'
    ]) +
    '{filter:brightness(0) invert(1)!important}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){' +
    scopeAll([
      CART, PLACEHOLDER, HEART,
      CART + ' svg *', HEART + ' svg *',
      HEART + ' svg', HEART + ' img', HEART + ' i', HEART + '::before', HEART + '::after'
    ]) +
    '{transition:none!important}' +
    '}';
  document.head.appendChild(style);

  function rescan() {
    try {
      if (window.ProductCardWishlistHearts && window.ProductCardWishlistHearts.rescan) {
        window.ProductCardWishlistHearts.rescan();
      }
    } catch (e) {}
  }

  function place() {
    scheduled = false;
    var marked = false;
    document.querySelectorAll(scope(CARD)).forEach(function (card) {
      if (!card.classList.contains(MARK)) {
        card.classList.add(MARK);
        marked = true;
      }
      var actions = card.querySelector(ACTIONS);
      var btn = card.querySelector(WISH);
      if (!actions || !btn) return;
      if (btn.parentElement !== actions) {
        var placeholder = actions.querySelector('[data-pcarousel-wishlist]');
        if (placeholder) placeholder.remove();
        actions.prepend(btn);
      }
      btn.setAttribute('data-mb-placed', '');
    });
    if (marked) rescan();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(place, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', function () { rescan(); schedule(); });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
